module.exports = "/_next/static/resources/art2-5dc56550508783992d845ce1c902094c.jpg";